"use client";
import Link from "next/link";
export default function Example() {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="bg-[#2B3252] mt-4 ">
      <div className="mx-auto max-w-5xl p-4 lg:flex lg:items-center lg:justify-between ">
        <div>
          <h2 className="max-w-2xl  blogSubtitle text-white">
          Ready to book or have questions?
          </h2>{" "}
          <br />
          <p className="max-w-4xl  pr-3  mx-auto text-white">
            We’re just a message away! Call us at the number provided, send an
            email, or click 'Book Now' for a fast and easy booking experience.
            We’re here to help make your ride hassle-free!
          </p>
        </div>
        <div className="mt-12 flex">
          <div className="text-white text-lg font-semibold ">
            {" "}
          <a href="tel:+1 (888) 346 9886"> <p>+1 (888) 346 9886</p></a>
           <a href="mailto:contact@prestigeride.com"> <p>contact@prestigeride.com</p></a>
            <Link href={"/"}>
              <button
                onClick={scrollTop}
                className="bg-[#d5af34] text-[#2B3252] pr-4 pl-4 mb-7 pt-2 pb-2 rounded-md mt-3"
              >
                BOOK NOW
              </button>
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom Button */}
    </div>
  );
}
